import { Breakpoint } from '@altibox/lte-salgskanaler-design-system-component-lib';
import React, { FunctionComponent } from 'react';

import { Equipment } from 'src/api/@generated/backend-api';

import { q22ImageProps } from 'src/resources/images';

import { StyledCheckbox, StyledImage, StyledMacText } from './decoder-select.styled';

interface Props {
  onSelect: (mac: string) => void;
  stb: Equipment;
  selected: boolean;
}

export const DecoderSelect: FunctionComponent<Props> = (props) => {
  const { onSelect, stb, selected } = props;

  return (
    <StyledCheckbox key={stb.mac} onChange={() => onSelect(stb.mac)} checked={selected}>
      <StyledImage {...q22ImageProps} />
      <StyledMacText variant="paragraph1" component="p" maxBreakpoint={Breakpoint.TABLET}>
        {stb.mac}
      </StyledMacText>
    </StyledCheckbox>
  );
};
